import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./BootcampProgress.module.scss";
import {useBootcampProgressLogic} from "./BootcampProgress.logic";
import BootcampProgressCard from "../../../components/dashboard/BootcampProgressCard";

export const BootcampProgress: VoidFunctionComponent = () => {
  const {rookie, intermediate, advanced} = useBootcampProgressLogic();
  return (
    <section className={s.container}>
      <BootcampProgressCard difficultyLevel={`rookie`} lessonsCompleted={rookie?.completedLessons} lessonsTotal={rookie?.availableLessons} />
      <BootcampProgressCard difficultyLevel={`intermediate`} lessonsCompleted={intermediate?.completedLessons} lessonsTotal={intermediate?.availableLessons} />
      <BootcampProgressCard difficultyLevel={`advanced`} lessonsCompleted={advanced?.completedLessons} lessonsTotal={advanced?.availableLessons} />
    </section>
  );
}
